/*
 * • FCSE Travelsearch Sandbox 2013 •
 *
 * © Copyright 2013, Tom Hulser [freshcells systems engineering GmbH]
 *
 *
 */

/**
 * DefaultController:error preload module
 *
 * @author Marvin Strenger, strenger@freshcells.de
 */
define([
    'jQuery',
    'library/fcse-widget/widget',
    'library/fcse-compatibility/object'],
    function($, Widget, Object) {
        var ForwardPaging = function(element, options)
        {
            Widget.apply(this, arguments);
            
            var defaultOptions = {
                defaultPageIndex: 1
            };
            
            //Add default options and custom options
            this.addOptions(defaultOptions, options);

            // Register Click-Event
            this._registerClickEvent();
        };

        ForwardPaging.prototype = $.extend(Object.create(Widget.prototype),
        {
            /**
             * Registers click events
             */            
            _registerClickEvent: function ()
            {
                this.element.on("click", $.proxy(this._setPageOnClick, this));
            },
            
            /**
             * Set Page on Click-Handler
             */
            _setPageOnClick: function(event)
            {
                // Prevent Default Handling
                event.preventDefault();

                // Replace Current Page
                var currentValue = this.getValue();
                currentValue.currentIndex = ++currentValue.currentIndex;

                this.setValue(currentValue);            
            },
            
            /**
             * Set Value to Ui
             */            
            setValueToUi: function()
            {
                // Not implemented
            },
            
            /**
             * Get Value from Ui
             */
            getValueFromUi: function()
            {
                var paging = this.getValue();

                return paging ? paging.currentIndex : this.option('defaultPageIndex');
            },

            /**
             * Resets paging to 1
             */
            reset: function()
            {
                var paging = this.getValue();
                var defaultPageIndex = this.option('defaultPageIndex');

                if (paging.currentIndex !== defaultPageIndex) {
                    paging.currentIndex = defaultPageIndex;

                    this.setValue(paging);
                }
            }
        });

        return ForwardPaging;
    });


//////////////////
// WEBPACK FOOTER
// ./~/fcse-content/forwardPaging.js
// module id = 410
// module chunks = 5 6